module.exports = __webpack_public_path__ + "img/2.268ad766.jpg";